import { useParams } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { ExpenseReportEditView } from '@webapp/modules/expense/feature-sets/ExpenseReportEditView'
import messages from './messages'

export const ExpenseEditPage = () => {
  const { uuid } = useParams<{ uuid: string }>()
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.pageTitle)}
      breadcrumbs={[
        {
          link: url('ExpenseStatusPage', { status: 'pending' }),
          name: intl.formatMessage(messages.expenseStatusBreadcrumb),
        },
        {
          name: intl.formatMessage(messages.pageTitle),
        },
      ]}
    >
      <ExpenseReportEditView uuid={uuid} />
    </Page>
  )
}
